
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { 
  Container,
  Pagination,
  Tab, 
  Tabs,
  Typography,
  useMediaQuery,
  Button,
  Grid,
  TextField,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  ListItem,
  ListItemText,
  List,
  Autocomplete,
  Box ,
  IconButton,
  Dialog, DialogTitle, DialogContent,
  Alert} from '@mui/material';
  import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
  import { DatePicker } from '@mui/x-date-pickers/DatePicker';
  import styles from './Depository.module.css';
  import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
  import AppConfig from '../AppConfig';
  import ApiClient from '../utilities/apiClient';
  import { useAppData } from '../redux/appDataProvider';
  import { useSelector } from 'react-redux';
  import dayjs from 'dayjs';
  import MyModal from "../components/session_expired"
  import MyLodder from '../components/lodder';
  import xlsexport from 'xlsexport'
  import exportFromJSON from 'export-from-json'; 
  import { Fragment } from 'react';
import { color } from 'd3';
import { fontSize } from '@mui/system';
import LayersIcon from "@mui/icons-material/Layers";
import CloseIcon from "@mui/icons-material/Close";

  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
  // Empty dependency array to fetch data only once on component mount
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  };

  CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const chartSetting = {
    xAxis: [
    ],
    width: 500,
    height: 400,
  };
  const dataset = [
    {
      seoul: 21,
      month: 'Invested',
    },
    {
      seoul: 28,
      month: 'Current',
    },
    {
      seoul: 41,
      month: 'Total Return',
    }
  ];


  const headerCells = ["Symbol","Qty","Buy avg." , "Buy value" , "Sell avg." , "Sell value" ,"Realised P&L" ,"Unrealised P&L"]

  const top100Films = [
    { label: 'Equity', id: 'NSE_CASH' },
    { label: 'Derivative', year: 'NSE_FNO' },
  ]

  const primary = {
    fontSize : "14px !important",
    color : "#999999 !important",
    width : "50% !important",
  }

  const secondary = {
    fontSize : "16px !important",
    color : "#FFFFFF !important",
    width : "50% !important",
    marginRight : "20px"
  }


  const reaslised1 = (ele) =>{
    if(parseFloat(ele.SALEQTY) == 0){
      return ((parseFloat(ele.SALEQTY) * parseFloat(ele.SALERATE)) - (parseInt(ele.BUYQTY) * parseFloat(ele.BUYRATE))).toFixed(2)
    }else{
      return ((parseFloat(ele.SALEQTY) * parseFloat(ele.SALERATE)) - (parseInt(ele.SALEQTY) * parseFloat(ele.BUYRATE))).toFixed(2)
    }
  }
  const Unrealised1 = (ele) =>{
    if(parseFloat(ele.SALEQTY) == 0){
      return ((parseInt(ele.BUYQTY) - parseFloat(ele.SALEQTY)) * (parseFloat(ele.CL_PRICE) == 0 ? 0 : parseFloat(ele.CL_PRICE)) - (parseInt(ele.BUYQTY) * parseFloat(ele.BUYRATE))).toFixed(2)
    }else{
      return ((parseInt(ele.BUYQTY) - parseFloat(ele.SALEQTY)) * (parseFloat(ele.CL_PRICE)) - ((parseInt(ele.BUYQTY)- parseFloat(ele.SALEQTY)) * parseFloat(ele.BUYRATE))).toFixed(2)
    }
  }

const PandL = (
  
  
  setDatePickerValue, 
  handleBOIDChange,
  
  handleDownload,
) => {
  const [page, setPage] = useState(0);
  const [mpage, setMPage] = useState(1);
  const [mdata,setMdata] = useState([]) 
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [value, setValue] = React.useState(0);
  const [segment, setSegment] = React.useState('Equity');
  const [selectedOption ,setSelectedOption] = React.useState("")
  const [dpdata, setDpdata] = React.useState([]);
  const [charges,setCharges] = React.useState(0)
  const [realisedPNL , setRealisedPNL] = React.useState(0)
  const [unRealisedPNL , setUnRealisedPNL] = React.useState(0)
  const [netRealised , setNetRealised] = React.useState(0)
  const { userInfo, setUserInfo } = useAppData();
  const [showmodal, setShowModal] = React.useState(false);
  const [showlodder, setShowLodder] = React.useState(false);
  const [year , setYear] = React.useState(false)
  const [fdate,SetFDate]= React.useState(dayjs(new Date(`04/01/${localStorage.getItem('year')}`)));
  const [tdate,SetTDate]= React.useState(dayjs(new Date(`03/31/${parseInt(localStorage.getItem('year')) + 1}`)));
  const { selectedYear, setSelectedYear } = useAppData();
  const [error,setError] = useState(false)
  const [openDialog, setOpenDialog] = useState(false)
  const [pandlExpenses, setPandlExpenses] = useState([])
  const [newPandlExpenses, setNewPandlExpenses] = useState([]) // Exp chrgs - dev srini - (28-03-25)
  const [pandlBrokerage, setPandlBrokerage] = useState([])
  const apiToken = useSelector(state => state.auth.apiToken);
  const screen900px = useMediaQuery('(max-width : 900px)')
  const screen1000px = useMediaQuery('(max-width : 1000px)') 
  const screen450px = useMediaQuery('(max-width : 450px)')


  const ur = (ele) =>{
    return (ele?.BUY_QTY * ele?.Closing_Price) - (ele?.BUY_QTY * ele?.BUY_RATE)
  } 

  const netr = () =>{ 
    const total = dpdata.reduce((acc,cv)=>{
      return acc += parseFloat(cv.PL_AMT)
    },0)
    return total
  }

  const sortedDpData = () =>{
    let arr = dpdata.map(e =>{
      return {...e , BUY_QTY : parseFloat(e.BUY_QTY) , BUY_RATE : parseFloat(e.BUY_RATE) ,SALE_QTY : parseFloat(e.SALE_QTY),SALE_RATE : parseFloat(e.SALE_RATE),SALE_AMT : parseFloat(e.SALE_AMT),BUY_AMT : parseFloat(e.BUY_AMT),PL_AMT : parseFloat(e.PL_AMT) }
    })
    let data = {} 
    arr.forEach(ele =>{
      if(!data.hasOwnProperty(ele.SCRIP_NAME)){
        data[ele.SCRIP_NAME] = [ele]
      }else{
        data[ele.SCRIP_NAME].push(ele)
      }
    })
    
    const a =  Object.entries(data).map(ele =>{
      return {name : ele[0] , data : ele[1]}
    })
    return a
  }  
 

  const netur = () =>{
    const total = dpdata?.reduce((acc,cv)=>{
      if(cv.BUY_QTY == cv.SALE_QTY){
        return acc += 0
      }else{
        acc += (cv?.BUY_QTY * cv?.Closing_Price) - (cv?.BUY_QTY * cv?.BUY_RATE)
      }
    return acc
    },0) 
    return total

  } 

 
  useEffect(()=>{  
    if(selectedOption == "Equity"){
      setRealisedPNL(netr()) 
      setUnRealisedPNL(netur())
      setNetRealised(netr() + charges)
    }else{
      setRealisedPNL(totalRealisedDerivative())
      setUnRealisedPNL(totalUnRealisedDerivative())
      setNetRealised(totalRealisedDerivative() + charges)
    }
  },[selectedOption , dpdata ])

  const totalRealisedDerivative = () =>{
    const total = dpdata.reduce((acc,cv)=>{
      if(parseFloat(cv.BUYQTY) == parseFloat(cv.SALEQTY)){ 
          return acc += parseFloat(cv.NET_PLAMT)
      }
      else if(parseFloat(cv.SALEQTY) == 0){ 
        return acc += 0
      }
      else{
         let a = ((parseFloat(cv.SALEQTY) * parseFloat(cv.SALERATE)))-(parseFloat(cv.SALEQTY) * parseFloat(cv.BUYRATE))
         acc += a
         return acc
      } 
    },0) 
    return total
  } 

  const totalUnRealisedDerivative = () =>{
    const total = dpdata.reduce((acc,cv)=>{ 
      if(parseFloat(cv.BUYQTY) == parseFloat(cv.SALEQTY)){
          return acc += 0
      } 
      else{
         let a = ((parseInt(cv.BUYQTY) - parseFloat(cv.SALEQTY)) * (parseFloat(cv.CL_PRICE)) - ((parseInt(cv.BUYQTY)- parseFloat(cv.SALEQTY)) * parseFloat(cv.BUYRATE)))
         acc += a
         return acc
      } 
    },0)   
    return total
  }


  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const ExportDistWise=(data)=> {
    // const link = document.createElement('a');

    
    // const filename = 'tradebook.xls';
    // const csv = new xlsexport(array, filename)
    // csv.exportToXLS(filename)
   
      const fileName = "Profit&Loss"
      const exportType = exportFromJSON.types.csv
      exportFromJSON({data,fileName,exportType})
  
  

} 
console.log(fdate)
console.log(dpdata,"dpdata")
const  handlePageChange = (event, newpage) => { 
  setPage(newpage); 
}
const  handleMPageChange = (event, newpage) => { 
  setMPage(newpage); 
}

useEffect(()=>{
  const newArr = dpdata && dpdata.slice((mpage - 1)*5 ,(mpage)*5)

  setMdata(newArr)
},[mpage,dpdata])

const handleRowsPerPageChange =(event) => { 
  setRowsPerPage(+event.target.value); 
  setPage(0); 
}
console.log(charges)

useEffect(()=>{
    SetFDate(dayjs(new Date(`04/01/${selectedYear.Database_Year}`)))
    SetTDate( dayjs(new Date(`03/31/${parseInt(selectedYear.Database_Year) + 1}`)))
    setYear(!year)
  }, [selectedYear]);

  useEffect(() => {
    window.scrollTo(0, 0)
    // let  fdate=dayjs(tdate).subtract(90, 'day')
    // SetFDate(dayjs(fdate)) 
    handleSubmit()
  }, [year]);  

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleSegment = (event, newValue) => {
    console.log(newValue)
    setSegment(newValue.label)
  
  };
 

  const  handleSubmit=()=>{

    if(tdate < fdate){
      return setError(true)
    }
    setError(false)
    setSelectedOption(segment)
    
    if(segment==="Derivative")
      {
      setShowLodder(true)
    try {
      const apiClient = new ApiClient(apiToken);
      apiClient.fetchData(
        AppConfig.api.PandL.derivative,
        "POST",
        {
          "COMPANY_CODE":"NSE_FNO",
          "FROM_DATE":fdate.format('DD/MM/YYYY'),
          "TO_DATE":tdate.format('DD/MM/YYYY'),
          "client_code":userInfo.CLIENT_ID ? userInfo.CLIENT_ID : localStorage.getItem("userid"),
          "Option_Op_Price": "Y",
          "FUTURE_OP_PRICE": "Y",
          
        })
        .then((response) => {
          console.info(response);
          setShowLodder(false)
          if(response===401){setShowModal(true)}
          if(response && response.Success == "False" && response.hasOwnProperty("Error Description"))
          {
            setDpdata([])
            setCharges(0)
          }
          if(response && response.Success == "True" && response.hasOwnProperty("Success Description")){
            let responseData = response["Success Description"]; 
            console.info(`data ${responseData}`);
            setDpdata(responseData.filter(ele => ele.SR == "1"))
            setCharges(responseData.filter(ele => ele.SR == "2" &&  !["*TURN OVER CHARGE*", "*TURNOVER CHARGE*"].includes(ele.SCRIP_SYMBOL) ).reduce((acc,cv)=>{
              return acc += parseFloat(cv.NETAMT)
            },0))
            // p&l brokerage - dev srini (21-03-25)
            setPandlExpenses(responseData.filter(ele => ele.SR == "2"))
            setPandlBrokerage(
              responseData
                .filter(charge => 
                  ["IBT20", "IBT30", "IBT40"].includes(charge.SCRIP_SYMBOL?.replace(/\*/g, ""))
                ) 
                .reduce((acc, cv) => acc + parseFloat(cv.NETAMT), 0)
            );
            
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.error('Error fetching holding data:', error);
    }
  }
    if(segment==="Equity")
    {
      setShowLodder(true)
    try {
      const apiClient = new ApiClient(apiToken);
      apiClient.fetchData(
        AppConfig.api.PandL.view,
        "POST",
        {
          
          "Client_code": userInfo.CLIENT_ID ? userInfo.CLIENT_ID : localStorage.getItem("userid"),
          "ToDate":tdate.format('DD/MM/YYYY'),
          "WithExp": "Y",
          "Profit": "A",
          "COCD": "BSE_CASH,NSE_CASH",
          "datayear": selectedYear.Database_Year ? selectedYear.Database_Year  : localStorage.getItem("year") ,
          "Logic_LTCG": "Y",
          // "Profit_Loss" : "N",
          // "Expense" : "Y"
          
        })
        .then((response) => {
          console.info(response);
          setShowLodder(false)
          if(response===401){setShowModal(true)}
          if(response && response.Success == "False" && response.hasOwnProperty("Error Description"))
          {
            setDpdata([])
          }
          if(response && response.Success == "True" && response.hasOwnProperty("Success Description")){
            let responseData = response["Success Description"]; 
            console.info(`p and l responsedataaaaaaaaaa ${responseData}`);
            setDpdata(responseData.filter(ele => ele.TR_TYPE !== "EXPENSES"))
            setCharges(responseData.filter(ele => ele.TR_TYPE == "EXPENSES" && !["*TURN OVER CHARGE*", "*TURNOVER CHARGE*"].includes(ele.SCRIP_SYMBOL)).reduce((acc,cv)=>{
              return acc += parseFloat(cv.NET_AMOUNT)
            },0))
            // p&l brokerage - dev srini (21-03-25)
            setPandlExpenses(responseData.filter(ele => ele.TR_TYPE == "EXPENSES"))
            setPandlBrokerage(
              responseData
                .filter(charge => 
                  ["IBT20", "IBT30", "IBT40"].includes(charge.SCRIP_SYMBOL?.replace(/\*/g, ""))
                ) 
                .reduce((acc, cv) => acc + parseFloat(cv.NET_AMOUNT), 0)
            );
          } 
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.error('Error fetching holding data:', error);
    }
  }
  }
  // p&l brokerage - dev srini (21-03-25)
  const handleClickOpen = () => setOpenDialog(true);
  const handleClose = () => setOpenDialog(false)
  // Exp chrgs - dev srini - (28-03-25)
  const expenseLabels = {
    "TOC BSE Exchange": "Exchange Transaction Charges",
    "TOC NSE Exchange": "Exchange Transaction Charges",
    "CGST": "Central GST",
    "SGST": "State GST",
    "IGST": "Integrated GST",
    "STT": "Securities Transaction Tax",
    "SEBITOC": "SEBI Turnover Fees",
    "STAMP DUTY": "Stamp Duty",
    "IPFTOC": "Investor Protection Trust Fund",
    "TURN OVER CHARGE": "Turn Over Charge",
    "TURNOVER CHARGE": "Turn Over Charge",
    "IBT20": "Brokerage",
    "IBT30": "Brokerage",
    "IBT40": "Brokerage",
    "IBT50": "Brokerage",
    "OTH1": "System Brokerage"
  }

  const expenseOrder = [
    "Exchange Transaction Charges",
    "Clearing Charges",
    "Central GST",
    "State GST",
    "Integrated GST",
    "Securities Transaction Tax",
    "SEBI Turnover Fees",
    "Stamp Duty",
    "Investor Protection Trust Fund",
    "System Brokerage",
    "Turn Over Charge",
    "Others"
  ]

  useEffect(() => {
    if (pandlExpenses.length > 0) {
      const mergedExpenses = {}
      
      pandlExpenses.forEach(({ SCRIP_SYMBOL, NETAMT , NET_AMOUNT }) => {
        const cleanedLabel = SCRIP_SYMBOL.replace(/\*/g, "")
        const label = expenseLabels[cleanedLabel] || "Others"

        if (!mergedExpenses[label]) {
          mergedExpenses[label] = 0
        }

        mergedExpenses[label] += Number(NETAMT) || Number(NET_AMOUNT)
      })

      expenseOrder.forEach((expenses) => {
        if (!mergedExpenses[expenses]) {
          mergedExpenses[expenses] = 0
        }
      })

      const formattedExpenses = Object.entries(mergedExpenses)
      .map(([label, amount]) => ({
        label,
        amount: Math.abs(amount).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      }))
      .sort((a, b) => expenseOrder.indexOf(a.label) - expenseOrder.indexOf(b.label))

      setNewPandlExpenses(formattedExpenses)

    }
  }, [pandlExpenses])
  
  return (
    <Container style={{padding: isSmallScreen ?"0px 0px" : '3% 1%' }} >
      
      {
        isSmallScreen ? <>
        <Grid sx={{background : "#1B2636" , minHeight : "100vh"}}   xs={12}>
          <Grid sx={{display : "flex", justifyContent : "space-between", width : "100%"}}>  
            {/* Margin left adjusted -02-08-24 - Dev Srini */}
            <Typography sx={{fontSize : "18px", margin : "30px 0px 20px 25px"}}>P&L</Typography> 
            <Button  
            variant="outlined" 
            size="large" 
            className={styles.outlinedButton}
            // Changed to onTouch event - 23-07-24 - Dev Srini
            onTouchStart={() => ExportDistWise(dpdata)} 
            sx={{margin : "30px 20px 20px 0px" , padding : "0px !important",fontSize : "18px"}}>Download</Button>
          </Grid>
          <Grid sx={{height : "60px", padding:"0px 20px 0px 20px"}} >  
            <Autocomplete  
            disableClearable
            size='small'
  
      disablePortal
      id="combo-box-demo"
      options={top100Films}
      value={segment} 
      onChange={handleSegment}
      
      sx={{"& .MuiInputBase-root": { height: 40 , background : "#131E2E","& .MuiOutlinedInput-notchedOutline": { border : "none" } }}}
      renderInput={(params) => <TextField {...params} label="Segment" />}
    />
            </Grid>
          <Grid sx={{display : "flex" , justifyContent : "space-between" , width : "100%"}} > 
                <LocalizationProvider
                    dateAdapter={AdapterDayjs}
                >
                    <DatePicker 
                        label="From Date"
                        size="small"
                        format="DD/MM/YYYY"
                        value={fdate}
                        onChange={(newValue) => SetFDate(newValue)}
                      disableFuture
                        sx={{borderRadius : "5px" ,marginLeft : "20px" ,"& .MuiInputBase-root": { height: 40, display: "flex", alignItems: "center" }, backgroundColor: "#131E2E", marginRight: 1 ,"& .MuiOutlinedInput-notchedOutline": { border : "none"}}}
                        fullWidth 
                    />
                </LocalizationProvider>
                <LocalizationProvider
                    dateAdapter={AdapterDayjs}
                >
                    <DatePicker 
                        label="To Date"
                        size="small"
                       
                        format="DD/MM/YYYY"
                        value={tdate}
                        onChange={(newValue) => SetTDate(newValue)}
                        sx={{borderRadius : "5px",marginRight : "20px", "& .MuiInputBase-root": { height: 40, display: "flex", alignItems: "center" }, backgroundColor: "#131E2E","& .MuiOutlinedInput-notchedOutline": { border : "none" } }}
                        fullWidth
                    />
                </LocalizationProvider>
            </Grid> 
            { error && <Typography sx={{color : "red", margin: "5px 0px 5px 20px"}}>To Date should be greater than From Date </Typography>}
            <Grid  style={{margin : "20px 20px 0px 20px"}}>  
              {/* Changed to onTouch event - 23-07-24 - Dev Srini */}
                <Button 
                    variant="contained" 
                    size="large" 
                    className={styles.mainbutton}
                    fullWidth
                    onTouchStart={() => handleSubmit()}
                >Submit</Button>
            </Grid>
          <Grid sx={{backgroundColor : "#131E2E" , margin : "20px 20px 30px 20px" ,    borderRadius : "12px" , padding : "20px"}}> 
              <Grid sx={{display : "flex",marginBottom : "10px"}}>  
              <Grid sx={{width : "50%"}}> 
              <Typography sx={{fontSize : "12px"}}>Realised P&L</Typography>
                  {/* Fixed - realisedPNL.toFixed(2) - dev, srini - (19-03-2025) */}
                <Typography sx={{fontSize : screen450px ? "17px" : "20px",color : realisedPNL < 0 && "#FF4747" || realisedPNL > 0 && "#03E743"}}>{realisedPNL < 0 ? realisedPNL.toFixed(2) : `+${realisedPNL.toFixed(2)}`}</Typography>
              </Grid>
              <Grid sx={{width : "50%"}}> 
              <Typography sx={{fontSize : "12px"}}>Unrealised P&L</Typography>
                <Typography sx={{fontSize : screen450px ? "17px" : "20px",color : unRealisedPNL < 0 && "#FF4747" || unRealisedPNL > 0 && "#03E743"}}>{(unRealisedPNL < 0 ? unRealisedPNL.toFixed(2) : `+${unRealisedPNL.toFixed(2)}`) }</Typography>
              </Grid>  
              </Grid>
               <Grid sx={{display : "flex" ,justifyContent : "space-between" ,marginBottom : "10px"}}> 
                {/* start - p&l brokerage - dev srini (21-03-25) */}
                <Typography sx={{fontSize : "14px"}}>Charges & taxes
                <IconButton onClick={handleClickOpen} style={{ color: "#F3D45E" }}>
                  <LayersIcon style={{ fontSize: 18, color: "#F3D45E" }} />
                </IconButton>
                </Typography>
                <Typography sx={{fontSize :  "14px"}}>{Math.abs(charges).toFixed(2)}</Typography>

                <Dialog open={openDialog} onClose={handleClose} maxWidth="xs" >
                      <DialogTitle  
                        style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: '0px', background: '#282c34', color: "#fff", textAlign: "start"  }}>
                        <span>Charges</span>
                        <IconButton onClick={handleClose} style={{ color: "#fff" }}>
                          <CloseIcon />
                        </IconButton>
                      </DialogTitle>

                    
                <DialogContent style={{ background: '#282c34', padding: '16px', }}>
                      <Grid container style={{ background: '#0B1420', padding: '8px', textAlign: 'center', fontSize: '16px'  }}>
                          <Grid item xs={12}>TradeBoss Charges</Grid>
                      </Grid>

                      <Grid container style={{ padding: "8px", background: "", borderBottom: "1px solid #ddd" }}>
                        <Grid item xs={9}>Brokerage</Grid>
                        <Grid item xs={3} style={{ textAlign: "right" }}>{Math.abs(pandlBrokerage).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</Grid>
                      </Grid>

                      <Grid container style={{ background: "#0B1420", padding: "8px", textAlign: "center", marginTop: "10px" }}>
                        <Grid item xs={12}>Statutory charges (Levied by the government and exchanges)</Grid>
                      </Grid>
                      {/* Exp chrgs - dev srini - (28-03-25) */}
                      <Grid style={{ paddingBottom:'4px' }}></Grid>

                        {newPandlExpenses.length > 0 &&
                          newPandlExpenses
                          .filter(charge => !["Brokerage", "Turn Over Charge"].includes(charge.label))
                          .map((charge, index) => (
                              <Grid container key={index} style={{ padding: "8px", borderBottom: "1px  #ddd" }}>
                                <Grid item xs={9}>{charge.label}</Grid>
                                <Grid item xs={3} style={{ textAlign: "right" }}>{charge.amount}</Grid>
                              </Grid>
                            ))
                        }

                </DialogContent>
              </Dialog>
              {/* end - p&l brokerage - dev srini (21-03-25) */}
               </Grid>
               <Grid sx={{display : "flex" ,justifyContent : "space-between",marginBottom : "10px"}}> 
                <Typography sx={{fontSize : "14px"}}>Other credits & debits</Typography>
                <Typography sx={{fontSize : "14px"}}>0</Typography>
               </Grid>
               <Grid sx={{display : "flex" ,justifyContent : "space-between"}}> 
                <Typography sx={{fontSize : "14px"}}>Net realised P&L</Typography>
                <Typography sx={{fontSize : "14px",color : netRealised < 0 && "#FF4747" || netRealised > 0 && "#03E743"}}>{netRealised.toFixed(2)}</Typography>
               </Grid>
            </Grid> 
            {/* Font size 1px increased -02-08-24 - Dev Srini */}
              <Typography sx={{display : "inline",fontSize : "13px" ,background : "#00ACFE33",borderRadius : "20px", padding : "10px", margin : "10px 0px 0px 20px"}}>  
              {`Last updated : ${dayjs(new Date()).format ("DD-MM-YYYY")}`}
              </Typography> 
              {/* Only margin top applied and removed padding -02-08-24 - Dev Srini */}
            <List sx={{marginTop: "5%"}}>

              {(selectedOption == "Equity" && dpdata.length!==0) && mdata.sort((a,b)=>{
                return a.SCRIP_NAME - b.SCRIP_NAME
              }).map(e => {
                return {...e , BUY_QTY : parseFloat(e.BUY_QTY) , BUY_RATE : parseFloat(e.BUY_RATE) ,SALE_QTY : parseFloat(e.SALE_QTY),SALE_RATE : parseFloat(e.SALE_RATE),SALE_AMT : parseFloat(e.SALE_AMT),BUY_AMT : parseFloat(e.BUY_AMT),PL_AMT : parseFloat(e.PL_AMT) } 
              }).map(ele =>{ 
                return(
                  <ListItem sx={{borderTop : "1px solid #000000",borderBottom : "1px solid #000000",display : "flex" , flexDirection : "column" , alignItems : "start"}}>
                    <ListItemText
                sx={{width : "100%"}}  
                primary = { 
                  <Grid display="flex"> 
                  {/* Commneted header -02-08-24 - Dev Srini */}
                    {/* <Typography sx={primary}>Scrip Name</Typography> */}
                    {/* <Typography sx={primary}>Qty</Typography>   */}
                  </Grid>   
                }
                secondary = {<Grid display="flex">
                  {/* Capitalise style applied for scrip name -02-08-24 - Dev Srini */}
                  <Typography sx={{...secondary, whiteSpace: "nowrap", textTransform: "capitalize"}}>{ele.SCRIP_NAME.toLowerCase()}</Typography>
                  {/* Qty alignment adjusted in mobile view -02-08-24 - Dev Srini */}
                  <Typography sx={{...primary, marginLeft:"15%"}} >Qty</Typography>
                  <Typography sx={{...secondary, marginLeft:"2%"}}> 
                  {ele.BUY_QTY}</Typography>
                </Grid>} 
                />
                <ListItemText
                sx={{width : "100%"}}  
                primary = { 
                  <Grid display="flex" > 
                  {/* Commneted header -02-08-24 - Dev Srini */}
                    {/* <Typography sx={primary}>Realised</Typography>
                    <Typography sx={primary}>UnRealised</Typography>   */}
                  </Grid>   
                }
                secondary = {<Grid display="flex">
                  {/*  Header added in same line of value -02-08-24 - Dev Srini */}
                  <Typography sx={primary}>Realised</Typography>

                  <Typography sx={{...secondary, marginLeft: "2%",}}>{ele.BUY_QTY == ele.SALE_QTY ?
                  <Typography sx={{fontSize : "14px",color : ele.PL_AMT > 0 ? "#03E743" : "#FF4747" }}>
                   {ele.PL_AMT} </Typography> :"-"}</Typography>
                    {/* Header added in same line of value -02-08-24 - Dev Srini */}
                  <Typography sx={primary}>UnRealised</Typography>
                  
                  <Typography sx={{...secondary, marginLeft: "2%",}}>{ele.BUY_QTY != ele.SALE_QTY ?
                  <Typography sx={{fontSize : "14px",color : ur(ele) > 0 ? "#03E743" : "#FF4747" }}>
                   {ur(ele) < 0 ? ur(ele).toFixed(2)  : `+${ur(ele).toFixed(2)}`} </Typography> :"-"}</Typography>
                </Grid>}  
                />
                <ListItemText
                sx={{width : "100%"}}  
                primary = { 
                  <Grid display="flex" > 
                  {/* Commented Header -02-08-24 - Dev Srini */}
                    {/* <Typography sx={primary}>Buy Avg</Typography>
                    <Typography sx={primary}>Buy Value</Typography>   */}
                  </Grid>   
                }
                secondary = {<Grid display="flex">
                  {/* Header added in same line of value -02-08-24 - Dev Srini */}
                  <Typography sx={primary}>Buy Avg</Typography>
                  <Typography sx={secondary}>{ele.BUY_RATE}</Typography>
                  {/* Header added in same line of value -02-08-24 - Dev Srini */}
                  <Typography sx={primary}>Buy Value</Typography>
                  <Typography sx={{...secondary, marginLeft: "2%"}}>{ele.BUY_AMT}</Typography>
                </Grid>} 
                />
                <ListItemText
                sx={{width : "100%"}}  
                primary = { 
                  <Grid display="flex" > 
                  {/* Commented Header -02-08-24 - Dev Srini */}
                    {/* <Typography sx={primary}>Sell Avg</Typography>
                    <Typography sx={primary}>Sell Value</Typography>   */}
                  </Grid>   
                }
                secondary = {<Grid display="flex">
                  {/* Header added in same line of value -02-08-24 - Dev Srini */}
                  <Typography sx={primary}>Sell Avg</Typography>
                  <Typography sx={secondary}>{ele.SALE_RATE == 0 ? "-" : ele.SALE_RATE}</Typography>
                  {/* Header added in same line of value -02-08-24 - Dev Srini */}
                  <Typography sx={primary}>Sell Value</Typography>
                  <Typography sx={secondary}>{ele.SALE_AMT == 0 ? "-" : ele.SALE_AMT}</Typography>
                </Grid>} 
                />
                  </ListItem>
                )
              })}

              {selectedOption == "Derivative" && dpdata.length!==0 && mdata.map(e=>{
                return {...e ,BUYQTY : parseFloat(e.BUYQTY),BUYRATE : parseFloat(e.BUYRATE),BUYAMT : parseFloat(e.BUYAMT),SALERATE : parseFloat(e.SALERATE),SALEAMT : parseFloat(e.SALEAMT) , SALEQTY : parseFloat(e.SALEQTY),NET_PLAMT : parseFloat(e.NET_PLAMT)}
              }).map((ele,index)=>{
                return (
                  <ListItem sx={{borderTop : "2px solid #000000",borderBottom : "2px solid #000000",display : "flex" , flexDirection : "column" , alignItems : "start"}}>
                <ListItemText
                sx={{width : "100%"}}  
                primary = { 
                  <Grid display="flex" >
                    <Typography sx={primary}>Scrip Name</Typography>
                    <Typography sx={primary}>Qty</Typography>  
                  </Grid>
                }
                secondary = {<Grid display="flex">
                  <Typography sx={secondary}>{ele.SCRIP_SYMBOL}</Typography>
                  <Typography sx={secondary}>{parseInt(ele.BUYQTY) }</Typography>
                </Grid>} 
                />
                <ListItemText
                sx={{width : "100%"}}  
                primary = { 
                  <Grid display="flex">
                    <Typography sx={primary}>Realised P&L</Typography>
                    <Typography sx={primary}>UnRealised P&L</Typography>  
                  </Grid>
                }
                secondary = {
                <Grid display="flex">
                  <Typography sx={secondary}> 
                  {parseInt(ele.BUYQTY) == Math.abs(ele.SALEQTY) ? (
                <Typography sx={{color : ele.NET_PLAMT > 0 ? "lightgreen" : "red" }}>
                  {ele.NET_PLAMT > 0 ? `+${ele.NET_PLAMT.toFixed(2)}` : ele.NET_PLAMT.toFixed(2)}
                </Typography>) : (
                  <Typography>
                  {ele.BUYQTY != ele.SALEQTY ? ele.SALEQTY == "0" ? "-" : (
                    <Typography sx={{fontSize : "14px",color : reaslised1(ele) > 0 ? "lightgreen" : "red" }}>
                    {reaslised1(ele) > 0 ? `+${reaslised1(ele)}` : reaslised1(ele)}
                  </Typography>
                    )  : 
                <Typography sx={{fontSize : "14px",color : reaslised1(ele) > 0 ? "lightgreen" : "red" }}>
                  {reaslised1(ele) > 0 ? `+${reaslised1(ele)}` : reaslised1(ele)}
                </Typography>}
                  </Typography>
                )}
              </Typography>
                  <Typography sx={secondary} >{ele.BUYQTY == Math.abs(ele.SALEQTY) ? ele.SALEQTY !== "0" ? "-" :
                  (
                     <Typography sx={{fontSize : "14px",color : Unrealised1(ele) > 0 ? "lightgreen" : "red" }}>
                     {Unrealised1(ele) > 0 ? `+${Unrealised1(ele)}` : Unrealised1(ele)}
                   </Typography> 
                     ) : 
                <Typography sx={{fontSize : "14px",color : Unrealised1(ele) > 0 ? "lightgreen" : "red" }}>
                  {Unrealised1(ele) > 0 ? `+${Unrealised1(ele)}` : Unrealised1(ele)}
                </Typography>}
                </Typography>
                </Grid>} 
                />
                <ListItemText
                sx={{width : "100%"}}  
                primary = { 
                  <Grid display="flex" >
                    <Typography sx={primary}>Buy Avg</Typography>
                    <Typography sx={primary}>Buy Value</Typography>  
                  </Grid>
                }
                secondary = {<Grid display="flex" >
                  <Typography sx={secondary}>{parseFloat(ele.BUYRATE).toFixed(2)}</Typography>
                  <Typography sx={secondary}>{parseFloat(ele.BUYAMT).toFixed(2) }</Typography>
                </Grid>} 
                />
                <ListItemText
                sx={{width : "100%"}}  
                primary = { 
                  <Grid display="flex" >
                    <Typography sx={primary}>Sell Avg</Typography>
                    <Typography sx={primary}>Sell Value</Typography>  
                  </Grid>
                }
                secondary = {<Grid display="flex">
                  <Typography sx={secondary}>{parseFloat(ele.SALERATE).toFixed(2)}</Typography>
                  <Typography sx={secondary}>{parseFloat(ele.SALEAMT).toFixed(2) }</Typography>
                </Grid>} 
                />
              </ListItem>
                )
              }) }  
            </List>            
            <Grid sx={{display : "flex",justifyContent : "center" , padding : "10px 0px 10px 0px"}}>
            <Pagination showFirstButton showLastButton count={Math.ceil(dpdata.length / 5)} size="small" page={mpage} 
              onChange={handleMPageChange} />
            </Grid>
        </Grid>
      </> : <>
      <Typography >Profit and Loss</Typography>
      <Grid container style={{marginTop:'1%'}}   >
         
        <Grid style={{display:'flex',width:'100%', height : "60px"}}>
            <Grid  style={{width:'25%' , marginRight : "10px"}}> 
            <Autocomplete  
            disableClearable
            size='small'

      disablePortal
      id="combo-box-demo"
      options={top100Films}
      value={segment} 
      onChange={handleSegment}
      fullWidth
      sx={{"& .MuiInputBase-root": { height: 40 , background : "#131E2E","& .MuiOutlinedInput-notchedOutline": { border : "none" } }}}
      renderInput={(params) => <TextField {...params} label="Segment" />}
    />
            </Grid>
           
            <Grid  style={{width:screen1000px ? '30%' : '20%'}}> 
                <LocalizationProvider
                    dateAdapter={AdapterDayjs}
                >
                    <DatePicker 
                        label="From Date"
                        size="small"
                        format="DD/MM/YYYY"
                        value={fdate}
                        onChange={(newValue) => SetFDate(newValue)}
                        disableFuture
                        sx={{ "& .MuiInputBase-root": { height: 40, display: "flex", alignItems: "center" }, backgroundColor: "#131E2E", marginRight: 1 ,"& .MuiOutlinedInput-notchedOutline": { border : "none" }}}
                        fullWidth
                    />
                </LocalizationProvider>
            </Grid>
            <Grid  style={{width: screen1000px ? '30%' : '20%'}}> 
                <LocalizationProvider
                    dateAdapter={AdapterDayjs}
                >
                    <DatePicker 
                        label="To Date"
                        size="small"
                        format="DD/MM/YYYY"
                        value={tdate}
                       
                        onChange={(newValue) => SetTDate(newValue)}
                        sx={{ "& .MuiInputBase-root": { height: 40, display: "flex", alignItems: "center" }, backgroundColor: "#131E2E", marginRight: 1,"& .MuiOutlinedInput-notchedOutline": { border : "none" } }}
                        fullWidth
                    />
                </LocalizationProvider>
            </Grid>
            <Grid  style={{width:'15%'}}> 
                <Button 
                    variant="contained" 
                    size="large" 
                    className={styles.mainbutton}
                    fullWidth
                    onClick={() => handleSubmit()} 
                >Submit</Button>
            </Grid>
            </Grid>
            { error && <Typography sx={{color : "red", marginBottom : "10px"}}>To Date should be greater than From Date </Typography>}
           <Grid xs={12} sx={{background : "#131E2E" , borderRadius : "5px" , width : "100%", padding : screen900px ? "20px 50px" : "20px 0px" }} container>
            <Grid className={styles.PLSummary}  xs={screen900px && 4}> 
              <Grid>   
              <Typography className={styles.PLText}>Realised P&L</Typography>
              <Typography className={styles.PL} sx={{color : realisedPNL < 0 && "#FF4747" || realisedPNL > 0 && "#03E743"}}>{realisedPNL < 0 ? realisedPNL.toFixed(2) : `+${realisedPNL.toFixed(2)}`}</Typography>
              
              </Grid>
            </Grid>
            <Grid className={styles.PLSummary} xs={screen900px && 4} >
              <Grid>
            <Typography className={styles.PLText}>Charges & taxes</Typography>
            {/* start - p&l brokerage - dev srini (21-03-25) */}
              <Grid display='flex' alignItems='center'>
              <Typography className={styles.PL}>{Math.abs(charges).toFixed(2)}</Typography>
                <IconButton onClick={handleClickOpen} style={{ color: "#F3D45E" }}>
                  <LayersIcon style={{ fontSize: 18, color: "#F3D45E", marginLeft: '5px' }} />
                </IconButton>
              </Grid>
          
                <Dialog open={openDialog} onClose={handleClose} maxWidth="xs">
                        <DialogTitle style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: '0px', background: '#282c34', color: "#fff", textAlign: "start" }}>
                          <span>Charges</span>
                          <IconButton onClick={handleClose} style={{ color: "#fff" }}>
                            <CloseIcon />
                          </IconButton>
                        </DialogTitle>

                      
                  <DialogContent style={{ background: '#282c34', padding: '16px', paddingTop: '8px' }}>
                        <Grid container style={{ background: '#0B1420', padding: '8px', textAlign: 'center'  }}>
                            <Grid item xs={12}>TradeBoss Charges</Grid>
                        </Grid>

                        <Grid container style={{ padding: "8px", background: "", borderBottom: "1px solid #ddd" }}>
                          <Grid item xs={9}>Brokerage</Grid>
                          {/* Exp chrgs - dev srini - (28-03-25) */}
                          <Grid item xs={3} style={{ textAlign: "right" }}>
                            {Math.abs(pandlBrokerage).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                          </Grid>
                        </Grid>

                        <Grid container style={{ background: "#0B1420", padding: "8px", textAlign: "center", marginTop: "10px", fontSize: '12px' }}>
                          <Grid item xs={12}>Statutory charges (Levied by the government and exchanges)</Grid>
                        </Grid>

                        <Grid style={{ paddingBottom:'12px'}}></Grid>
                          {/* Exp chrgs - dev srini - (28-03-25) */}
                          {newPandlExpenses.length > 0 &&
                            newPandlExpenses
                            .filter(charge => !["Brokerage", "Turn Over Charge"].includes(charge.label))
                            .map((charge, index) => (
                                <Grid container key={index} style={{ padding: "8px", fontSize: '14px', borderBottom: "1px #ddd" }}>
                                  <Grid item xs={9} >{charge.label}</Grid>
                                  <Grid item xs={3} style={{ textAlign: "right" }}>{charge.amount}</Grid>
                                </Grid>
                              ))
                          }

                  </DialogContent>
                </Dialog>
              {/* end - p&l brokerage - dev srini (21-03-25) */}
              </Grid>
            </Grid>
            
            <Grid className={styles.PLSummary} xs={screen900px && 4}>
              <Grid>
              <Typography className={styles.PLText}>Other credits & debits</Typography>
              
            <Typography className={styles.PL}>0</Typography>
            
              </Grid>
            </Grid>
            <Grid className={styles.PLSummary}  sx={{marginTop : screen900px && "20px"}} xs={screen900px && 4} > 
              <Grid > 
              <Typography className={styles.PLText}>Net realised P&L</Typography>
              
            <Typography className={styles.PL} sx={{color : netRealised < 0 && "#FF4747" || netRealised > 0 && "#03E743"}}>{netRealised.toFixed(2)}</Typography>
              </Grid>   
            </Grid>
            <Grid className={styles.PLSummary} sx={{marginTop : screen900px && "20px"}} xs={screen900px && 4} >
              <Grid> 
              <Typography className={styles.PLText}>UnRealised P&L</Typography>
              
            <Typography className={styles.PL} sx={{color : unRealisedPNL < 0 && "#FF4747" || unRealisedPNL > 0 && "#03E743"}}>{(unRealisedPNL < 0 ? unRealisedPNL.toFixed(2) : `+${unRealisedPNL.toFixed(2)}`) }</Typography>
              </Grid>
            </Grid>
            </Grid>
            <Grid sx={{display : "flex",justifyContent : "end", width : "100%"}} > 
                <Button  
                    variant="outlined"   
                    size="large" 
                    className={styles.outlinedButton} 
                    sx={{paddingRight : "0px !important"}}
                     onClick={() => ExportDistWise(dpdata)} 
                >Download</Button>
            </Grid>
            <TableContainer component={Paper} className={styles.tablecontainer} sx={{marginTop : "10px",width : "100%" , background : "#0B1420"}}>
      
          <Table> 
          <TableHead> 
            <TableRow>
              { dpdata.length!==0  && headerCells.map((column,index) =>{
                return(
                  <TableCell className={styles.table_h} sx={{whiteSpace : "nowrap" , border : "1px solid #515151" , borderLeft : selectedOption == "Equity" ?  (index != 0 && "none") : "none", borderRight : selectedOption == "Equity" ? ((index == 0 || index == headerCells.length-1) ? "1px solid #515151" : "none") : ("none") }} >{column}</TableCell>
                )
              })}
            </TableRow>
          </TableHead> 
          <TableBody>
          {dpdata.length===0 &&   
              
              <TableRow  style={{display:'flex',justifyContent:'center',width:'60vw'}}>
                 
                      
                          <Alert severity="warning" style={{background:'transparent'}}>No Transactions found !</Alert>
                      
                 
              </TableRow>
          
          }

          {(selectedOption == "Equity" && dpdata.length!==0) && sortedDpData().map(ele =>{
            return(
              <Fragment>
              <TableRow>
                <TableCell sx={{border : "1px solid #515151", width : "25%"}} rowSpan={ele.data.length + 1}>
                  {ele.name} 
                </TableCell>
              </TableRow>
              {ele.data.map((e) => (
                <TableRow>
                  <>
                  <TableCell>{e.BUY_QTY}</TableCell>
                  <TableCell>{e.BUY_RATE}</TableCell>
                  <TableCell>{e.BUY_AMT}</TableCell>
                  <TableCell>{e.SALE_RATE == 0 ? "-" : e.SALE_RATE}</TableCell>
                  <TableCell>{e.SALE_AMT == 0 ? "-" : e.SALE_AMT}</TableCell>
                  <TableCell >
                  {e.BUY_QTY == e.SALE_QTY ?
                  <Typography sx={{fontSize : "14px",color : e.PL_AMT > 0 ? "#03E743" : "#FF4747" }}>
                   {e.PL_AMT} </Typography> :"-"}
                    </TableCell> 
                    <TableCell sx={{borderRight : " 1px solid #515151 !important"}} >
                  {e.BUY_QTY != e.SALE_QTY ?
                  <Typography sx={{fontSize : "14px",color : ur(e) > 0 ? "#03E743" : "#FF4747" }}>
                   {ur(e) < 0 ? ur(e).toFixed(2)  : `+${ur(e).toFixed(2)}`} </Typography> :"-"} 
                    </TableCell> 
                  </>
                </TableRow>
              ))} 
            </Fragment>   
            )
          }) }

          {selectedOption == "Derivative" && dpdata.length!==0 && dpdata.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(e=>{
            if(selectedOption == "Equity"){
              return {...e , BUY_QTY : parseFloat(e.BUY_QTY) , BUY_RATE : parseFloat(e.BUY_RATE) ,SALE_QTY : parseFloat(e.SALE_QTY),SALE_RATE : parseFloat(e.SALE_RATE),SALE_AMT : parseFloat(e.SALE_AMT),BUY_AMT : parseFloat(e.BUY_AMT),PL_AMT : parseFloat(e.PL_AMT) }
              
            }else{
              return {...e ,BUYQTY : parseFloat(e.BUYQTY),BUYRATE : parseFloat(e.BUYRATE),BUYAMT : parseFloat(e.BUYAMT),SALERATE : parseFloat(e.SALERATE),SALEAMT : parseFloat(e.SALEAMT) , SALEQTY : parseFloat(e.SALEQTY),NET_PLAMT : parseFloat(e.NET_PLAMT)}
            }
          }).map((ele, index) => ( 
              <TableRow key={index}>  
                { selectedOption == "Derivative" && (      
                  <> 
                  <TableCell>{ele.SCRIP_SYMBOL}</TableCell>
                <TableCell>{parseInt(ele.BUYQTY) }</TableCell>
                <TableCell>{parseFloat(ele.BUYRATE).toFixed(2)}</TableCell>
                <TableCell>{parseFloat(ele.BUYAMT).toFixed(2) }</TableCell>
                <TableCell>{parseFloat(ele.SALERATE).toFixed(2)}</TableCell>
                <TableCell>{parseFloat(ele.SALEAMT).toFixed(2) }</TableCell> 
                {parseInt(ele.BUYQTY) == Math.abs(ele.SALEQTY) ? (
                <TableCell sx={{color : ele.NET_PLAMT > 0 ? "lightgreen" : "red" }}>
                  {ele.NET_PLAMT > 0 ? `+${ele.NET_PLAMT.toFixed(2)}` : ele.NET_PLAMT.toFixed(2)}
                </TableCell>) : (
                <TableCell>
                  {ele.BUYQTY != ele.SALEQTY ? ele.SALEQTY == "0" ? "-" : (
                    <Typography sx={{fontSize : "14px",color : reaslised1(ele) > 0 ? "lightgreen" : "red" }}>
                    {reaslised1(ele) > 0 ? `+${reaslised1(ele)}` : reaslised1(ele)}
                  </Typography>
                    )  : 
                <Typography sx={{fontSize : "14px",color : reaslised1(ele) > 0 ? "lightgreen" : "red" }}>
                  {reaslised1(ele) > 0 ? `+${reaslised1(ele)}` : reaslised1(ele)}
                </Typography>}
                  </TableCell>  )}

                  <TableCell >{ele.BUYQTY == Math.abs(ele.SALEQTY) ? ele.SALEQTY !== "0" ? "-" :
                  (
                     <Typography sx={{fontSize : "14px",color : Unrealised1(ele) > 0 ? "lightgreen" : "red" }}>
                     {Unrealised1(ele) > 0 ? `+${Unrealised1(ele)}` : Unrealised1(ele)}
                   </Typography>
                     ) : 
                <Typography sx={{fontSize : "14px",color : Unrealised1(ele) > 0 ? "lightgreen" : "red" }}>
                  {Unrealised1(ele) > 0 ? `+${Unrealised1(ele)}` : Unrealised1(ele)}
                </Typography>}
                </TableCell>
                  </>
                )}
                 
              </TableRow>
            ))}
          </TableBody>
        </Table>
        </TableContainer>
        {dpdata.length > 0 && <TablePagination
              sx={{background : "#0B1420" , width : "100%"}}  
              rowsPerPageOptions={[10, 20, 50]}
              rowsPerPage={rowsPerPage}
              page={page}
              count={dpdata.length}
              component="div"
             onPageChange={handlePageChange}
              onRowsPerPageChange={handleRowsPerPageChange} 
          />  }
        </Grid>
      </>
    }
    <MyModal canShow={showmodal}/>
    <MyLodder canShow={showlodder}/>
    </Container>
  );
 
};

export default PandL;
